{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "HEADER": "Shopify",
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Отменить",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Интеграции",
    "DESCRIPTION": "Chatwoot интегрируется с несколькими инструментами и сервисами, чтобы повысить эффективность вашей команды. Изучите список ниже, чтобы настроить ваши любимые приложения.",
    "LEARN_MORE": "Узнать больше об интеграциях",
    "LOADING": "Получение интеграций",
    "SEARCH_PLACEHOLDER": "Search integrations...",
    "NO_RESULTS": "No integrations found matching your search",
    "CAPTAIN": {
      "DISABLED": "Капитан не включен на вашем аккаунте.",
      "CLICK_HERE_TO_CONFIGURE": "Нажмите здесь, чтобы настроить",
      "LOADING_CONSOLE": "Загрузка консоли Капитана...",
      "FAILED_TO_LOAD_CONSOLE": "Не удалось загрузить консоль Капитана. Пожалуйста, обновите страницу и повторите попытку."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "События с подпиской",
      "LEARN_MORE": "Узнать больше о вебхуках",
      "PAYWALL": {
        "TITLE": "Webhooks are available on paid plans",
        "AVAILABLE_ON": "Use webhooks to receive real-time events from your Chatwoot account.",
        "UPGRADE_PROMPT": "Upgrade to the Startups, Business, or Enterprise plan to use webhooks.",
        "UPGRADE_NOW": "Обновить сейчас",
        "CANCEL_ANYTIME": "Change or cancel your plan anytime."
      },
      "SECRET": {
        "LABEL": "Secret",
        "COPY": "Copy secret to clipboard",
        "COPY_SUCCESS": "Secret copied to clipboard",
        "TOGGLE": "Toggle secret visibility",
        "CREATED_DESC": "Your webhook has been created. Use the secret below to verify webhook signatures. Please copy it now — you can also find it later in the webhook edit form.",
        "DONE": "Done"
      },
      "COUNT": "{n} webhook | {n} webhooks",
      "SEARCH_PLACEHOLDER": "Search webhooks...",
      "NO_RESULTS": "No webhooks found matching your search",
      "FORM": {
        "CANCEL": "Отменить",
        "DESC": "Вебхуки позволяют получить вам информацию о том, что происходит в вашей учетной записи Chatwoot. Пожалуйста, введите корректный URL.",
        "SUBSCRIPTIONS": {
          "LABEL": "События",
          "EVENTS": {
            "CONVERSATION_CREATED": "Диалог создан",
            "CONVERSATION_STATUS_CHANGED": "Статус диалога изменён",
            "CONVERSATION_UPDATED": "Диалог обновлён",
            "MESSAGE_CREATED": "Сообщение создано",
            "MESSAGE_UPDATED": "Сообщение обновлено",
            "WEBWIDGET_TRIGGERED": "Виджет онлайн чата, открыт пользователем",
            "CONTACT_CREATED": "Контакт создан",
            "CONTACT_UPDATED": "Контакт обновлен",
            "CONVERSATION_TYPING_ON": "Печатание во время разговора включено",
            "CONVERSATION_TYPING_OFF": "Печатание во время разговора выключено",
            "INBOX_UPDATED": "Inbox updated"
          }
        },
        "NAME": {
          "LABEL": "Webhook Name",
          "PLACEHOLDER": "Enter the name of the webhook"
        },
        "END_POINT": {
          "LABEL": "URL вебхука",
          "PLACEHOLDER": "Пример: {webhookExampleURL}",
          "ERROR": "Пожалуйста, введите правильный URL"
        },
        "EDIT_SUBMIT": "Обновить webhook",
        "ADD_SUBMIT": "Создать вебхук"
      },
      "TITLE": "Вебхук",
      "CONFIGURE": "Настроить",
      "HEADER": "Настройки вебхуков",
      "HEADER_BTN_TXT": "Добавить новый вебхук",
      "LOADING": "Получение подключенных вебхуков",
      "SEARCH_404": "Нет вебхуков, соответствующих запросу",
      "SIDEBAR_TXT": "<p><b>Вебхуки</b> </p> <p>Вебхуки – это HTTP запросы, которые можно установить для любого аккаунта. Они вызываются по событиям: например, при создании новых сообщений в Chatwoot. Вы можете создать сколько угодно вебхуков для этой учетной записи. <br /><br /> Для создания <b>вебхука</b>, нажмите на кнопку <b>Добавить новый вебхук</b>. Вы также можете удалить любой существующий вебхук, нажав на кнопку Удалить.</p>",
      "LIST": {
        "404": "У вас нет вебхуков.",
        "TITLE": "Управление вебхуками",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Адрес вебхука",
          "ACTIONS": "Действия"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Редактировать",
        "TITLE": "Редактировать вебхук",
        "API": {
          "SUCCESS_MESSAGE": "Конфигурация вебхука успешно обновлена",
          "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
        }
      },
      "ADD": {
        "CANCEL": "Отменить",
        "TITLE": "Добавить новый вебхук",
        "API": {
          "SUCCESS_MESSAGE": "Конфигурация вебхука успешно добавлена",
          "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Удалить",
        "API": {
          "SUCCESS_MESSAGE": "Вебхук удален",
          "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
        },
        "CONFIRM": {
          "TITLE": "Подтвердите удаление",
          "MESSAGE": "Вы уверены, что хотите удалить вебхук? ({webhookURL})",
          "YES": "Да, удалить ",
          "NO": "Нет, не удалять"
        }
      }
    },
    "SLACK": {
      "HEADER": "Slack",
      "DELETE": "Удалить",
      "DELETE_CONFIRMATION": {
        "TITLE": "Удалить интеграцию",
        "MESSAGE": "Вы уверены, что хотите удалить интеграцию? Это приведет к потере доступа к диалогам на вашем рабочем пространстве."
      },
      "HELP_TEXT": {
        "TITLE": "Как использовать интеграцию Slack?",
        "BODY": "С этой интеграцией, все входящие диалоги будут синхронизированы с **{selectedChannelName}*** каналом в вашей рабочей области Slack. Вы можете управлять переписками клиентов прямо на канале и никогда не пропускать сообщения.\n\nВот основные особенности интеграции:\n\n**Ответить на диалоги из Slack:** Чтобы ответить на разговор в ***{selectedChannelName}*** канале Slack, просто напечатайте ваше сообщение и отправьте его. Это создаст ответ клиенту через Chatwoot. Это так просто!\n\n **Создавайте личные заметки:** Если вы хотите создавать личные заметки вместо ответов, начните свое сообщение с ***`note:`***. Это гарантирует, что ваше сообщение будет приватным и не будет видно клиенту.\n\n**Связать профиль агента:** Если человек, ответивший в Slack имеет профиль агента в Chatwoot с такой же электронной почты, ответы будут автоматически связаны с профилем этого агента. Это означает, что вы легко можете отслеживать кто, когда и что ответил,. С другой стороны, если у отвечающего нет соответствующего профиля агента, ответы отправятся клиенту от имени бота.",
        "SELECTED": "выбрано"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Выбрать канал",
        "UPDATE": "Обновить",
        "BUTTON_TEXT": "Подключить канал",
        "DESCRIPTION": "Рабочая область Slack теперь связана с Chatwoot. Однако интеграция в настоящее время неактивна. Чтобы активировать интеграцию и подключить канал к чату, нажмите на кнопку ниже.\n\n**Примечание:** Если вы пытаетесь подключить частный канал, добавьте приложение Чатвут в канал Slack перед тем как приступить к этому шагу.",
        "ATTENTION_REQUIRED": "Требуется внимание",
        "EXPIRED": "Ваша интеграция в Slack истекла. Чтобы продолжить получение сообщений в Slack, удалите интеграцию и подключите рабочую область снова."
      },
      "UPDATE_ERROR": "Произошла ошибка при обновлении интеграции, пожалуйста, попробуйте еще раз",
      "UPDATE_SUCCESS": "Канал успешно подключен",
      "FAILED_TO_FETCH_CHANNELS": "Произошла ошибка при получении каналов из Slack, попробуйте еще раз"
    },
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Нажмите, чтобы присоединиться",
      "LEAVE_THE_ROOM": "Выйти из комнаты",
      "START_VIDEO_CALL_HELP_TEXT": "Начать новый видеозвонок с клиентом",
      "JOIN_ERROR": "Произошла ошибка при подключении к вызову, попробуйте еще раз",
      "CREATE_ERROR": "Произошла ошибка при создании ссылки на встречу, попробуйте еще раз"
    },
    "OPEN_AI": {
      "AI_ASSIST": "Помощь ИИ",
      "WITH_AI": " {option} с ИИ ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Предложить ответ",
        "SUMMARIZE": "Подведем итог",
        "REPHRASE": "Улучшить написание",
        "FIX_SPELLING_GRAMMAR": "Исправить правописание и грамматику",
        "SHORTEN": "Сократить",
        "EXPAND": "Развернуть",
        "MAKE_FRIENDLY": "Изменить тон сообщения на дружеский",
        "MAKE_FORMAL": "Использовать официальный тон",
        "SIMPLIFY": "Упростить",
        "CONFIDENT": "Use confident tone",
        "PROFESSIONAL": "Use professional tone",
        "CASUAL": "Use casual tone",
        "STRAIGHTFORWARD": "Use straightforward tone"
      },
      "REPLY_OPTIONS": {
        "IMPROVE_REPLY": "Improve reply",
        "IMPROVE_REPLY_SELECTION": "Improve the selection",
        "CHANGE_TONE": {
          "TITLE": "Change tone",
          "OPTIONS": {
            "PROFESSIONAL": "Профессиональный",
            "CASUAL": "Casual",
            "STRAIGHTFORWARD": "Straightforward",
            "CONFIDENT": "Confident",
            "FRIENDLY": "Дружелюбный"
          }
        },
        "GRAMMAR": "Fix grammar & spelling",
        "SUGGESTION": "Suggest a reply",
        "SUMMARIZE": "Summarize the conversation",
        "ASK_COPILOT": "Ask Copilot"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Содержание черновика",
        "GENERATED_TITLE": "Генерированное содержимое",
        "AI_WRITING": "ИИ пишет",
        "BUTTONS": {
          "APPLY": "Использовать этот вариант перевода",
          "CANCEL": "Отменить"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Интеграция с OpenAI",
        "DESC": "Принесите дополнительные функции AI на вашу панель управления с помощью моделей GPT OpenAI. Чтобы начать, введите API ключ из вашей учетной записи OpenAI.",
        "KEY_PLACEHOLDER": "Введите ваш OpenAI API ключ",
        "BUTTONS": {
          "NEED_HELP": "Нужна помощь?",
          "DISMISS": "Отклонить",
          "FINISH": "Завершить установку"
        },
        "DISMISS_MESSAGE": "Вы можете настроить интеграцию OpenAI позже, когда хотите.",
        "SUCCESS_MESSAGE": "Интеграция OpenAI успешно настроена"
      },
      "TITLE": "Улучшить с ИИ",
      "SUMMARY_TITLE": "Сводка с ИИ",
      "REPLY_TITLE": "Ответить с помощью ИИ",
      "SUBTITLE": "Улучшенный ответ будет создан с помощью AI, основанный на текущем проекте.",
      "TONE": {
        "TITLE": "Тон",
        "OPTIONS": {
          "PROFESSIONAL": "Профессиональный",
          "FRIENDLY": "Дружелюбный"
        }
      },
      "BUTTONS": {
        "GENERATE": "Создать",
        "GENERATING": "Создание...",
        "CANCEL": "Отменить"
      },
      "GENERATE_ERROR": "При сохранении настроек произошла ошибка, пожалуйста, попробуйте еще раз"
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "API": {
        "SUCCESS_MESSAGE": "Интеграция удалена"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Подключить"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Панель приложений",
      "HEADER_BTN_TXT": "Добавить новое приложение",
      "SIDEBAR_TXT": "<p><b>Панель приложений</b></p><p>Панель приложений, позволяют организациям встраивать приложение в панель управления Chatwoot, чтобы предоставлять контекст для агентов службы поддержки клиентов. Эта функция позволяет вам создать приложение независимо и встроить его в панель инструментов для предоставления информации о пользователях, их заказах или их предыдущей истории платежей.</p><p>Когда вы встраиваете свое приложение с помощью панели инструментов в Chatwoot, ваше приложение будет получить контекст разговора и связей событий. Реализуйте связи для события сообщения на своей странице, чтобы получать контекст.</p><p>Чтобы добавить новое приложение панели приложений, нажмите кнопку \"Добавить приложение\".</p>",
      "DESCRIPTION": "Панель приложений, позволяют организациям встраивать приложение внутри панели управления для обеспечения контекста агентов по поддержке клиентов. Эта функция позволяет создать приложение независимо и встраивать информацию о пользователе, его заказах или их истории платежей.",
      "LEARN_MORE": "Подробнее об интеграциях",
      "COUNT": "{n} dashboard app | {n} dashboard apps",
      "SEARCH_PLACEHOLDER": "Search dashboard apps...",
      "NO_RESULTS": "No dashboard apps found matching your search",
      "LIST": {
        "404": "В этой панели приложений не настроено ни одной интеграции",
        "LOADING": "Загрузка приложений...",
        "TABLE_HEADER": {
          "NAME": "Имя",
          "ENDPOINT": "Endpoint",
          "ACTIONS": "Действия"
        },
        "EDIT_TOOLTIP": "Редактировать приложение",
        "DELETE_TOOLTIP": "Удалить приложение"
      },
      "FORM": {
        "TITLE_LABEL": "Имя",
        "TITLE_PLACEHOLDER": "Введите имя для вашего приложения",
        "TITLE_ERROR": "Требуется название для панели приложений",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Введите URL-адрес конечной точки, где размещено приложение",
        "URL_ERROR": "Требуется действительный URL"
      },
      "CREATE": {
        "HEADER": "Добавить новое приложение",
        "FORM_SUBMIT": "Отправить",
        "FORM_CANCEL": "Отменить",
        "API_SUCCESS": "Приложение панели инструментов успешно настроено",
        "API_ERROR": "Не удалось обновить настройки входящих сообщений. Пожалуйста, повторите попытку позже"
      },
      "UPDATE": {
        "HEADER": "Редактировать приложение",
        "FORM_SUBMIT": "Обновить",
        "FORM_CANCEL": "Отменить",
        "API_SUCCESS": "Приложение панели инструментов успешно обновлено",
        "API_ERROR": "Не удалось обновить приложение. Повторите попытку позже"
      },
      "DELETE": {
        "CONFIRM_YES": "Да, удалить",
        "CONFIRM_NO": "Нет, не удалять",
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы уверены, что хотите удалить приложение - {appName}?",
        "API_SUCCESS": "Приложение успешно удалено",
        "API_ERROR": "Не удалось удалить приложение. Повторите попытку позже"
      }
    },
    "LINEAR": {
      "HEADER": "Linear",
      "ADD_OR_LINK_BUTTON": "Создать/Связать Задачу",
      "LOADING": "Загрузка связанных задач...",
      "LOADING_ERROR": "Ошибка получения данных о связанных задачах, пожалуйста попробуйте еще раз",
      "CREATE": "Создать",
      "LINK": {
        "SEARCH": "Поиск задач",
        "SELECT": "Выбрать задачу",
        "TITLE": "Ссылка",
        "EMPTY_LIST": "Связанных проблем не найдено",
        "LOADING": "Загрузка",
        "ERROR": "Ошибка получения данных о связанных задачах, пожалуйста попробуйте еще раз",
        "LINK_SUCCESS": "Связывание задачи прошло успешно",
        "LINK_ERROR": "При привязке этой задачи произошла проблема",
        "LINK_TITLE": "Диалог (#{conversationId}) с {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Создать/Привязать задачу из linear",
        "DESCRIPTION": "Создать задачу из linear из сообщения или привязать существующую задачу",
        "FORM": {
          "TITLE": {
            "LABEL": "Название",
            "PLACEHOLDER": "Введите название",
            "REQUIRED_ERROR": "Необходимо указать название"
          },
          "DESCRIPTION": {
            "LABEL": "Описание",
            "PLACEHOLDER": "Введите описание"
          },
          "TEAM": {
            "LABEL": "Команда",
            "PLACEHOLDER": "Выберите команду",
            "SEARCH": "Найти команду",
            "REQUIRED_ERROR": "Требуется команда"
          },
          "ASSIGNEE": {
            "LABEL": "Назначено",
            "PLACEHOLDER": "Выбрать ответственного",
            "SEARCH": "Поиск ответственного"
          },
          "PRIORITY": {
            "LABEL": "Приоритет",
            "PLACEHOLDER": "Выберите приоритет",
            "SEARCH": "Приоритет поиска"
          },
          "LABEL": {
            "LABEL": "Метка",
            "PLACEHOLDER": "Выбрать метку",
            "SEARCH": "Поиск меток"
          },
          "STATUS": {
            "LABEL": "Статус",
            "PLACEHOLDER": "Выбрать статус",
            "SEARCH": "Статус поиска"
          },
          "PROJECT": {
            "LABEL": "Проект",
            "PLACEHOLDER": "Выбрать проект",
            "SEARCH": "Поиск проекта"
          }
        },
        "CREATE": "Создать",
        "CANCEL": "Отменить",
        "CREATE_SUCCESS": "Проблема успешно создана",
        "CREATE_ERROR": "Произошла ошибка при создании проблемы, пожалуйста, попробуйте еще раз",
        "LOADING_TEAM_ERROR": "Ошибка получения данных о связанных задачах, пожалуйста попробуйте еще раз",
        "LOADING_TEAM_ENTITIES_ERROR": "Произошла ошибка при получении элементов команды, попробуйте еще раз"
      },
      "ISSUE": {
        "STATUS": "Статус",
        "PRIORITY": "Приоритет",
        "ASSIGNEE": "Назначено",
        "LABELS": "Категории",
        "CREATED_AT": "Создано {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Отвязать",
        "SUCCESS": "Задача успешно отвязана",
        "ERROR": "Произошла ошибка при отвязке задачи, пожалуйста, попробуйте ещё раз"
      },
      "NO_LINKED_ISSUES": "Не найдено связанных задач",
      "DELETE": {
        "TITLE": "Вы уверены, что хотите удалить интеграцию?",
        "MESSAGE": "Вы уверены, что хотите удалить интеграцию?",
        "CONFIRM": "Да, удалить",
        "CANCEL": "Отменить"
      },
      "CTA": {
        "TITLE": "Подключение к Linear",
        "AGENT_DESCRIPTION": "Linear workspace не подключено. Попросите администратора подключить рабочую область, чтобы использовать эту интеграцию.",
        "DESCRIPTION": "Linear workspace не подключено. Нажмите на кнопку ниже, чтобы подключить рабочую область, чтобы использовать эту интеграцию.",
        "BUTTON_TEXT": "Подключить Linear workspace"
      }
    },
    "NOTION": {
      "HEADER": "Notion",
      "DELETE": {
        "TITLE": "Вы уверены, что хотите удалить интеграцию с Notion?",
        "MESSAGE": "Удаление этой интеграции приведет к удалению доступа к вашему проекту Notion и остановит все связанные функции.",
        "CONFIRM": "Да, удалить",
        "CANCEL": "Отменить"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Капитан",
    "HEADER_KNOW_MORE": "Узнать больше",
    "OVERVIEW": {
      "HEADER": "Обзор",
      "WELCOME": {
        "LABEL": "Captain summary",
        "LOADING": "Generating summary…"
      },
      "INBOX_BANNER": {
        "TEXT": "This assistant isn't connected to any inbox yet, so it won't respond to conversations.",
        "ACTION": "Connect inbox",
        "DISMISS": "Отклонить"
      },
      "COVERAGE_BANNER": {
        "TEXT": "{count} FAQs are pending review, keeping coverage at {coverage}%. Approve them so your assistant can resolve more on its own.",
        "ACTION": "Review FAQs",
        "DISMISS": "Отклонить"
      },
      "RANGES": {
        "LAST_DAYS": "Last {count} days",
        "THIS_MONTH": "This month",
        "LAST_MONTH": "Last month"
      },
      "METRICS": {
        "HANDLED": {
          "LABEL": "Conversations handled",
          "HINT": "Distinct conversations this assistant replied in."
        },
        "AUTO_RESOLUTION": {
          "LABEL": "Auto-resolution rate",
          "HINT": "Share of handled conversations closed without a human reply."
        },
        "HANDOFF": {
          "LABEL": "Handoff rate",
          "HINT": "Share of handled conversations escalated to a human agent."
        },
        "HOURS_SAVED": {
          "LABEL": "Time saved",
          "HINT": "Estimate: Captain replies times ~2 minutes of assumed agent effort per reply. Directional, not measured labor."
        },
        "REOPEN": {
          "LABEL": "Reopen rate",
          "HINT": "Auto-resolved conversations that were reopened afterwards."
        },
        "DEPTH": {
          "LABEL": "Messages / conversation",
          "HINT": "Average replies the assistant sends per conversation."
        }
      },
      "DRILLDOWN": {
        "CLOSE": "Close details",
        "EMPTY": "No records found for this metric.",
        "ERROR": "Could not load records. Please try again.",
        "LOAD_MORE": "Загрузить ещё",
        "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations"
      },
      "KNOWLEDGE": {
        "TITLE": "Knowledge coverage",
        "COVERAGE": "{pct}% approved",
        "APPROVED": "Approved FAQs",
        "PENDING": "Pending FAQs",
        "DOCUMENTS": "Документы"
      },
      "LINKS": {
        "DOCS": {
          "TITLE": "Captain docs",
          "DESCRIPTION": "Guides and how-tos for Captain"
        },
        "PLAYGROUND": {
          "TITLE": "Площадка",
          "DESCRIPTION": "Test this assistant's replies"
        },
        "BILLING": {
          "TITLE": "Платёж",
          "DESCRIPTION": "Manage credits and plan"
        }
      }
    },
    "ASSISTANT_SWITCHER": {
      "ASSISTANTS": "Ассистенты",
      "SWITCH_ASSISTANT": "Переключиться между помощниками",
      "NEW_ASSISTANT": "Создать помощника",
      "EMPTY_LIST": "Список помощников пуст, пожалуйста, создайте помощника, чтобы начать работу"
    },
    "COPILOT": {
      "TITLE": "Copilot",
      "TRY_THESE_PROMPTS": "Попробуйте эти запросы",
      "PANEL_TITLE": "Начать работу с Copilot",
      "KICK_OFF_MESSAGE": "Хотите узнать суть или проверить прошлые диалоги или написать лучший ответ? Copilot здесь, чтобы ускорить работу.",
      "SEND_MESSAGE": "Отправить сообщение...",
      "EMPTY_MESSAGE": "Произошла ошибка при генерации ответа. Пожалуйста, попробуйте еще раз.",
      "LOADER": "Капитан думает",
      "YOU": "Вы",
      "USE": "Использовать это",
      "RESET": "Сброс",
      "SHOW_STEPS": "Показать шаги",
      "SELECT_ASSISTANT": "Выбрать ассистента",
      "PROMPTS": {
        "SUMMARIZE": {
          "LABEL": "Подвести итог этого диалога",
          "CONTENT": "Кратко изложить основные моменты, обсуждавшиеся между клиентом и агентом поддержки, включая пожелания клиента, вопросы и решения или ответы, предоставляемые агентом поддержки"
        },
        "SUGGEST": {
          "LABEL": "Предложить ответ",
          "CONTENT": "Анализируйте запрос клиента и составляйте ответ, который эффективно учитывает его проблемы или вопросы. Убедитесь, что ответ является четким, кратким и содержит полезную информацию."
        },
        "RATE": {
          "LABEL": "Оцените этот диалог",
          "CONTENT": "Оцените разговор, чтобы узнать, насколько он соответствует потребностям клиента. Поделитесь оценкой из 5 на основе тона, ясности и эффективности."
        },
        "HIGH_PRIORITY": {
          "LABEL": "Диалоги с высоким приоритетом",
          "CONTENT": "Дайте мне суть всех высокоприоритетных открытых разговоров, включая идентификатор разговора, имя клиента (если есть), содержимое последнего сообщения и назначенный агент. Если нужно, группа по статусу."
        },
        "LIST_CONTACTS": {
          "LABEL": "Список контактов",
          "CONTENT": "Покажите мне список 10 топ контактов. Включая имя, email или номер телефона (если доступно), последний просмотренный время, тэги (если есть)."
        }
      }
    },
    "PLAYGROUND": {
      "USER": "Вы",
      "ASSISTANT": "Ассистент",
      "MESSAGE_PLACEHOLDER": "Введите сообщение...",
      "HEADER": "Площадка",
      "DESCRIPTION": "Используйте эту площадку, чтобы отправлять сообщения своему ассистенту и проверять правильность ответа, быстро и в том тоне, который вы ожидали.",
      "CREDIT_NOTE": "Отправленные здесь сообщения будут учитываться в кредитах Captain."
    },
    "PAYWALL": {
      "TITLE": "Обновите тарифный план, чтобы использовать Captain AI",
      "AVAILABLE_ON": "Капитан недоступен на бесплатном тарифном плане.",
      "UPGRADE_PROMPT": "Обновите тарифный план, чтобы получить доступ к нашим ассистентам, copilot и другим функциям.",
      "UPGRADE_NOW": "Обновить сейчас",
      "CANCEL_ANYTIME": "Вы можете изменить или отменить ваш тарифный план в любое время"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI доступен только в тарифных планах Enterprise.",
      "UPGRADE_PROMPT": "Обновите тарифный план, чтобы получить доступ к нашим ассистентам, copilot и другим функциям.",
      "ASK_ADMIN": "Пожалуйста, обратитесь к вашему администратору для обновления."
    },
    "BANNER": {
      "RESPONSES": "Вы использовали более 80% лимита ответов. Чтобы продолжить использование Captain AI, пожалуйста, обновите тариф.",
      "DOCUMENTS": "Достигнут лимит документов. Обновите тарифный план, чтобы продолжить использование Captain AI."
    },
    "FORM": {
      "CANCEL": "Отменить",
      "CREATE": "Создать",
      "EDIT": "Обновить"
    },
    "ASSISTANTS": {
      "HEADER": "Ассистенты",
      "NO_ASSISTANTS_AVAILABLE": "У вас нет ни одного доступного помощника.",
      "ADD_NEW": "Создать нового ассистента",
      "DELETE": {
        "TITLE": "Вы уверены, что хотите удалить ассистента?",
        "DESCRIPTION": "Это действие необратимо. Удаление этого ассистента удалит его из всех подключенных источников и навсегда удалит все сгенерированные знания.",
        "CONFIRM": "Да, удалить",
        "SUCCESS_MESSAGE": "Ассистент успешно удален",
        "ERROR_MESSAGE": "При удалении ассистента произошла ошибка. Пожалуйста, попробуйте еще раз."
      },
      "FORM_DESCRIPTION": "Заполните приведенные ниже сведения, чтобы назвать своего ассистента, описать его цель и указать поддерживаемый продукт.",
      "CREATE": {
        "TITLE": "Создать ассистента",
        "SUCCESS_MESSAGE": "Ассистент успешно создан",
        "ERROR_MESSAGE": "При создании ассистента произошла ошибка, пожалуйста, попробуйте еще раз."
      },
      "FORM": {
        "UPDATE": "Обновить",
        "SECTIONS": {
          "BASIC_INFO": "Основная информация",
          "SYSTEM_MESSAGES": "Системные сообщения",
          "INSTRUCTIONS": "Инструкции",
          "FEATURES": "Возможности",
          "TOOLS": "Инструменты "
        },
        "NAME": {
          "LABEL": "Имя",
          "PLACEHOLDER": "Введите имя помощника",
          "ERROR": "Имя обязательно"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Введите описание помощника",
          "ERROR": "Описание обязательно"
        },
        "PRODUCT_NAME": {
          "LABEL": "Название продукта",
          "PLACEHOLDER": "Введите название продукта",
          "ERROR": "Требуется название продукта"
        },
        "WELCOME_MESSAGE": {
          "LABEL": "Приветственное сообщение",
          "PLACEHOLDER": "Введите приветственное сообщение"
        },
        "HANDOFF_MESSAGE": {
          "LABEL": "Сообщение о передачи",
          "PLACEHOLDER": "Введите сообщение о передачи"
        },
        "RESOLUTION_MESSAGE": {
          "LABEL": "Сообщение разрешения",
          "PLACEHOLDER": "Введите сообщение разрешения"
        },
        "INSTRUCTIONS": {
          "LABEL": "Инструкции",
          "PLACEHOLDER": "Введите инструкции для помощника"
        },
        "FEATURES": {
          "TITLE": "Возможности",
          "ALLOW_CONVERSATION_FAQS": "Создать FAQ из решённых диалогов",
          "ALLOW_MEMORIES": "Сохраняйте ключевые детали в виде воспоминаний о взаимодействии с клиентами.",
          "ALLOW_CITATIONS": "Включить цитаты источника в ответы",
          "ALLOW_CONTACT_ATTRIBUTES": "Allow access to contact information"
        }
      },
      "EDIT": {
        "TITLE": "Обновить ассистента",
        "SUCCESS_MESSAGE": "Ассистент успешно обновлен",
        "ERROR_MESSAGE": "При обновлении ассистента произошла ошибка, пожалуйста, попробуйте еще раз.",
        "NOT_FOUND": "Не удалось найти помощника. Пожалуйста, попробуйте еще раз."
      },
      "SETTINGS": {
        "HEADER": "Настройки",
        "BASIC_SETTINGS": {
          "TITLE": "Основные настройки",
          "DESCRIPTION": "Настройте то, что говорит ассистент, завершая диалог или передавая человеку."
        },
        "SYSTEM_SETTINGS": {
          "TITLE": "Системные настройки",
          "DESCRIPTION": "Настройте то, что говорит ассистент, завершая диалог или передавая человеку."
        },
        "CONTROL_ITEMS": {
          "TITLE": "Веселые вещи",
          "DESCRIPTION": "Добавить больше контроля к ассистенту. (немного визуально, как история : Query guardrail → Сценарии → Выход) пользователь Nudges на самом деле их использует.",
          "OPTIONS": {
            "GUARDRAILS": {
              "TITLE": "Ограждения",
              "DESCRIPTION": "Сохраняет вещи в нужном контексте — только те вопросы, которые вы хотите, чтобы ваш ассистент отвечал, ничего запрещённого или не по теме."
            },
            "RESPONSE_GUIDELINES": {
              "TITLE": "Рекомендации по ответу",
              "DESCRIPTION": "Вайб и структура ответов помощника – ясные и дружелюбные? Коротко и непросто? Детально и формально?"
            }
          }
        },
        "DELETE": {
          "TITLE": "Удалить ассистента",
          "DESCRIPTION": "Это действие необратимо. Удаление этого ассистента удалит его из всех подключенных источников и навсегда удалит все сгенерированные знания.",
          "BUTTON_TEXT": "Удалить {assistantName}"
        }
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Редактировать ассистента",
        "DELETE_ASSISTANT": "Удалить ассистента",
        "VIEW_CONNECTED_INBOXES": "Просмотр подключенных источников"
      },
      "EMPTY_STATE": {
        "TITLE": "Нет доступных ассистентов",
        "SUBTITLE": "Создайте ассистента, чтобы дать быстрые и точные ответы пользователям. Он может учиться на ваших статьях из центра поддержки и прошлых диалогах.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      },
      "GUARDRAILS": {
        "TITLE": "Ограждения",
        "DESCRIPTION": "Сохраняет вещи в нужном контексте — только те вопросы, которые вы хотите, чтобы ваш ассистент отвечал, ничего запрещённого или не по теме.",
        "BULK_ACTION": {
          "SELECTED": "{count} элемент выбран | {count} элементов выбрано",
          "SELECT_ALL": "Выбрать все ({count})",
          "UNSELECT_ALL": "Сбросить все ({count})",
          "BULK_DELETE_BUTTON": "Удалить"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Примеры ограждений",
            "ADD": "Добавить все",
            "ADD_SINGLE": "Добавить это",
            "SAVE": "Добавить и сохранить (↵)",
            "PLACEHOLDER": "Введите другое ограждение..."
          },
          "NEW": {
            "TITLE": "Добавить гарант",
            "CREATE": "Создать",
            "CANCEL": "Отменить",
            "PLACEHOLDER": "Введите другое ограждение...",
            "TEST_ALL": "Проверить все"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Поиск..."
        },
        "EMPTY_MESSAGE": "Ограждений не найдено. Создайте или добавьте примеры, чтобы начать.",
        "SEARCH_EMPTY_MESSAGE": "Не найдено ограждений для этого поиска.",
        "API": {
          "ADD": {
            "SUCCESS": "Ограждение успешно добавлен",
            "ERROR": "Произошла ошибка при добавлении ограждения, пожалуйста, попробуйте еще раз."
          },
          "UPDATE": {
            "SUCCESS": "Ограждение успешно обновлено",
            "ERROR": "Произошла ошибка при обновлении ограждения, попробуйте еще раз."
          },
          "DELETE": {
            "SUCCESS": "Ограждение успешно удалено",
            "ERROR": "Произошла ошибка при удалении ограждения, пожалуйста, попробуйте еще раз."
          }
        }
      },
      "RESPONSE_GUIDELINES": {
        "TITLE": "Руководство по ограждению",
        "DESCRIPTION": "Вайб и структура ответов помощника – ясные и дружелюбные? Коротко и непросто? Детально и формально?",
        "BULK_ACTION": {
          "SELECTED": "{count} элемент выбран | {count} элементов выбрано",
          "SELECT_ALL": "Выбрать все ({count})",
          "UNSELECT_ALL": "Сбросить все ({count})",
          "BULK_DELETE_BUTTON": "Удалить"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Пример рекомендации по ответам",
            "ADD": "Добавить все",
            "ADD_SINGLE": "Добавить это",
            "SAVE": "Добавить и сохранить (↵)",
            "PLACEHOLDER": "Введите рекомендации по ответам..."
          },
          "NEW": {
            "TITLE": "Добавить руководство по ответу",
            "CREATE": "Создать",
            "CANCEL": "Отменить",
            "PLACEHOLDER": "Введите рекомендации по ответам...",
            "TEST_ALL": "Проверить все"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Поиск..."
        },
        "EMPTY_MESSAGE": "Руководство по ответу не найдено. Создайте или добавьте примеры, чтобы начать.",
        "SEARCH_EMPTY_MESSAGE": "По данному поиску не найдено ни одного руководства.",
        "API": {
          "ADD": {
            "SUCCESS": "Руководство по ответу успешно добавлено",
            "ERROR": "Произошла ошибка при добавлении правил ответа, пожалуйста, попробуйте еще раз."
          },
          "UPDATE": {
            "SUCCESS": "Руководства по ответу успешно обновлены",
            "ERROR": "Произошла ошибка при обновлении руководства для ответа, пожалуйста, попробуйте еще раз."
          },
          "DELETE": {
            "SUCCESS": "Руководства для ответа успешно удалены",
            "ERROR": "Произошла ошибка при удалении руководства для ответа, пожалуйста, попробуйте еще раз."
          }
        }
      },
      "SCENARIOS": {
        "TITLE": "Сценарии",
        "DESCRIPTION": "Дайте своему ассистенту определенный контекст, например «что делать, когда пользователь застрял» или «как действовать во время запроса на возмещение».",
        "BULK_ACTION": {
          "SELECTED": "{count} элемент выбран | {count} элементов выбрано",
          "SELECT_ALL": "Выбрать все ({count})",
          "UNSELECT_ALL": "Сбросить все ({count})",
          "BULK_DELETE_BUTTON": "Удалить"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Примеры сценариев",
            "ADD": "Добавить все",
            "ADD_SINGLE": "Добавить это",
            "TOOLS_USED": "Используемые инструменты:"
          },
          "NEW": {
            "CREATE": "Добавить сценарий",
            "TITLE": "Создать сценарий",
            "FORM": {
              "TITLE": {
                "LABEL": "Название",
                "PLACEHOLDER": "Введите название сценария",
                "ERROR": "Название сценария обязательно"
              },
              "DESCRIPTION": {
                "LABEL": "Описание",
                "PLACEHOLDER": "Опишите как и где будет использоваться этот сценарий",
                "ERROR": "Описание сценария обязательно"
              },
              "INSTRUCTION": {
                "LABEL": "Как обрабатывать",
                "PLACEHOLDER": "Опишите, как и где будет обрабатываться этот сценарий",
                "ERROR": "Содержимое сценария обязательно"
              },
              "CREATE": "Создать",
              "CANCEL": "Отменить"
            }
          }
        },
        "UPDATE": {
          "CANCEL": "Отменить",
          "UPDATE": "Обновить изменения"
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Поиск..."
        },
        "EMPTY_MESSAGE": "Сценарии не найдены. Создайте или добавьте примеры для начала.",
        "SEARCH_EMPTY_MESSAGE": "Не найдено сценариев для этого поиска.",
        "API": {
          "ADD": {
            "SUCCESS": "Сценарии успешно добавлены",
            "ERROR": "Произошла ошибка при добавлении сценариев, пожалуйста, попробуйте еще раз."
          },
          "UPDATE": {
            "SUCCESS": "Сценарий успешно обновлены",
            "ERROR": "Произошла ошибка при обновлении сценария, пожалуйста, попробуйте еще раз."
          },
          "DELETE": {
            "SUCCESS": "Сценарий успешно удалены",
            "ERROR": "При удалении сценария произошла ошибка. Пожалуйста, попробуйте еще раз."
          }
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Документы",
      "ADD_NEW": "Создать новый документ",
      "FAQ_COUNT": "{n} FAQ | {n} FAQs",
      "SELECTED": "Выбрано {count}",
      "SELECT_ALL": "Выбрать все ({count})",
      "UNSELECT_ALL": "Сбросить все ({count})",
      "BULK_DELETE_BUTTON": "Удалить",
      "BULK_SYNC_BUTTON": "Обновить",
      "BULK_DELETE": {
        "TITLE": "Delete documents?",
        "DESCRIPTION": "Are you sure you want to delete the selected documents? This action cannot be undone.",
        "CONFIRM": "Да, удалить всё",
        "SUCCESS_MESSAGE": "Documents deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the documents, please try again."
      },
      "BULK_SYNC": {
        "SUCCESS_MESSAGE_ONE": "Обновления поставлены в очередь для 1 документа",
        "SUCCESS_MESSAGE": "Обновления в очереди для документов {count}",
        "ZERO_MESSAGE": "Нет документов, помеченных для обновления.",
        "ERROR_MESSAGE": "При обновлении произошла ошибка, пожалуйста, попробуйте еще раз."
      },
      "SYNC": {
        "QUEUED_MESSAGE": "Обновляется очередь. Мы скоро обновим документ.",
        "ERROR_MESSAGE": "Не удалось обновить, попробуйте еще раз."
      },
      "FILTERS": {
        "SOURCE": {
          "ALL": "Все источники",
          "WEB": "Веб страницы",
          "PDF": "PDF-файлы"
        },
        "STATUS": {
          "ANY": "Любой статус",
          "UPDATED": "Обновлено",
          "NEEDS_UPDATE": "Необходимо обновить",
          "UPDATING": "Обновляется",
          "FAILED": "Не удалось"
        },
        "SORT": {
          "RECENTLY_UPDATED": "Недавно обновленные",
          "RECENTLY_CREATED": "Недавно созданные"
        },
        "SEARCH_PLACEHOLDER": "Поиск..."
      },
      "SYNC_STATUS": {
        "SYNCED": "последнее обновление {time}",
        "SYNCING": "обновление...",
        "STALE_SYNC": "обновление приостановлено",
        "FAILED": "Ошибка синхронизации",
        "NEVER_SYNCED": "еще не обновлено"
      },
      "SYNC_ERRORS": {
        "NOT_FOUND": "Страница не найдена",
        "ACCESS_DENIED": "Доступ запрещён",
        "TIMEOUT": "Страница заняла слишком много времени, чтобы ответить",
        "CONTENT_EMPTY": "Страница вернула пустое содержимое",
        "FETCH_FAILED": "Не удалось загрузить страницу",
        "SYNC_ERROR": "Неизвестная ошибка",
        "DEFAULT": "Ошибка синхронизации"
      },
      "RELATED_RESPONSES": {
        "TITLE": "Связанные FAQ",
        "EMPTY": "No FAQs have been generated from this document yet."
      },
      "DETAILS": {
        "DESCRIPTION": "Review the crawled content and the FAQs generated from this source.",
        "SOURCE": "Source",
        "GENERATED_FAQS": "Generated FAQs",
        "LAST_UPDATED": "Last updated",
        "NOT_AVAILABLE": "Недоступен",
        "CONTENT_TAB": "Crawled content",
        "PDF_TAB": "PDF details",
        "CONTENT_TITLE": "Crawled content",
        "PDF_TITLE": "PDF file",
        "PDF_DESCRIPTION": "Review the original PDF source.",
        "CHARACTER_COUNT": "{count} characters extracted",
        "COPY_CONTENT": "Копировать",
        "COPY_SUCCESS": "Crawled content copied to clipboard",
        "COPY_ERROR": "Could not copy crawled content",
        "VIEW_RAW": "View raw",
        "VIEW_PREVIEW": "View preview",
        "UNREADABLE_CONTENT": "Readable content could not be extracted from this document. You can view the raw extracted content.",
        "EMPTY_CONTENT": "No crawled content is available for this document yet."
      },
      "FORM_DESCRIPTION": "Введите URL документа, чтобы добавить его в качестве источника знаний и выберите ассистента, с которым он свяжется.",
      "CREATE": {
        "TITLE": "Добавить документ",
        "SUCCESS_MESSAGE": "Документ успешно создан",
        "ERROR_MESSAGE": "Произошла ошибка при создании документа, пожалуйста, попробуйте еще раз."
      },
      "FORM": {
        "TYPE": {
          "LABEL": "Тип документа",
          "URL": "URL",
          "PDF": "PDF файл"
        },
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Введите URL документа",
          "ERROR": "Пожалуйста, укажите корректный URL для документа"
        },
        "PDF_FILE": {
          "LABEL": "PDF файл",
          "CHOOSE_FILE": "Выберите PDF файл",
          "ERROR": "Пожалуйста, выберите PDF файл",
          "HELP_TEXT": "Максимальный размер файла: 10MB",
          "INVALID_TYPE": "Пожалуйста, выберите корректный файл PDF",
          "TOO_LARGE": "Размер файла превышает 10MB"
        },
        "NAME": {
          "LABEL": "Название документа (необязательно)",
          "PLACEHOLDER": "Введите название документа"
        }
      },
      "DELETE": {
        "TITLE": "Вы уверены, что хотите удалить этот документ?",
        "DESCRIPTION": "Это действие необратимо. Удаление этого документа навсегда удалит все сгенерированные знания.",
        "CONFIRM": "Да, удалить",
        "SUCCESS_MESSAGE": "Документ успешно удалён",
        "ERROR_MESSAGE": "При удалении документа произошла ошибка, пожалуйста, попробуйте еще раз."
      },
      "OPTIONS": {
        "VIEW_DETAILS": "Просмотреть подробности",
        "SYNC_NOW": "Обновите сейчас",
        "RETRY_SYNC": "Повторите обновление",
        "DELETE_DOCUMENT": "Удалить документ"
      },
      "EMPTY_STATE": {
        "TITLE": "Нет доступных документов",
        "SUBTITLE": "Документы используются Вашим ассистентом для создания FAQ. Вы можете импортировать документы для предоставления контекста для Вашего ассистента.",
        "FILTERED_TITLE": "Нет подходящих документов",
        "FILTERED_SUBTITLE": "Попробуйте изменить источник, статус или слово поиска.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "CUSTOM_TOOLS": {
      "HEADER": "Инструменты",
      "ADD_NEW": "Создать новый инструмент",
      "SOFT_LIMIT_WARNING": "Having more than 10 tools may reduce the assistant's reliability in selecting the right tool. Consider removing unused tools for better results.",
      "EMPTY_STATE": {
        "TITLE": "Нет доступных пользовательских инструментов",
        "SUBTITLE": "Создавайте пользовательские инструменты, чтобы подключить ассистента к внешним API и сервисам, позволяя получать данные и выполнять действия от вашего имени.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Пользовательские инструменты",
          "NOTE": "Пользовательские инструменты позволяют ассистенту взаимодействовать с внешними API и сервисами. Создавайте инструменты для получения данных, выполнения действий или интеграции с существующими системами для расширения возможностей вашего помощника."
        }
      },
      "FORM_DESCRIPTION": "Настройте пользовательский инструмент для соединения с внешними API",
      "OPTIONS": {
        "EDIT_TOOL": "Редактировать инструмент",
        "DELETE_TOOL": "Удалить инструмент"
      },
      "CREATE": {
        "TITLE": "Создать пользовательский инструмент",
        "SUCCESS_MESSAGE": "Пользовательский инструмент успешно создан",
        "ERROR_MESSAGE": "Не удалось создать пользовательский инструмент"
      },
      "EDIT": {
        "TITLE": "Редактировать пользовательский инструмент",
        "SUCCESS_MESSAGE": "Пользовательский инструмент успешно обновлен",
        "ERROR_MESSAGE": "Не удалось обновить пользовательский инструмент"
      },
      "DELETE": {
        "TITLE": "Удаление пользовательского инструмента",
        "DESCRIPTION": "Вы уверены, что хотите удалить этот пользовательский инструмент? Это действие нельзя отменить.",
        "CONFIRM": "Да, удалить",
        "SUCCESS_MESSAGE": "Пользовательский инструмент успешно удален",
        "ERROR_MESSAGE": "Не удалось удалить пользовательский инструмент"
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use tools with Captain",
        "AVAILABLE_ON": "Captain Tools are only available in Business and Enterprise plans. Please upgrade to Business plan to use the feature.",
        "UPGRADE_PROMPT": "",
        "UPGRADE_NOW": "Открыть платеж",
        "CANCEL_ANYTIME": ""
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Captain Tools are only available in the paid plans.",
        "UPGRADE_PROMPT": "Please upgrade to a paid plan to use this feature.",
        "ASK_ADMIN": "Пожалуйста, обратитесь к вашему администратору для обновления."
      },
      "TEST": {
        "BUTTON": "Test connection",
        "SUCCESS": "Endpoint returned HTTP {status}",
        "ERROR": "Connection failed",
        "DISABLED_HINT": "Testing is only available for endpoints without templates or request bodies."
      },
      "FORM": {
        "TITLE": {
          "LABEL": "Название инструмента",
          "PLACEHOLDER": "Поиск заказа",
          "ERROR": "Название инструмента обязательно",
          "MAX_LENGTH_ERROR": "Tool name must be {max} characters or fewer"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Поиск деталей заказа по ID"
        },
        "HTTP_METHOD": {
          "LABEL": "Метод"
        },
        "ENDPOINT_URL": {
          "LABEL": "Endpoint URL",
          "PLACEHOLDER": "https://api.example.com/orders/{'{{'} order_id {'}}'}",
          "ERROR": "Требуется корректный URL"
        },
        "AUTH_TYPE": {
          "LABEL": "Тип аутентификации"
        },
        "AUTH_TYPES": {
          "NONE": "Ничего",
          "BEARER": "Bearer Token",
          "BASIC": "Basic Auth",
          "API_KEY": "Ключ API"
        },
        "AUTH_CONFIG": {
          "BEARER_TOKEN": "Bearer Token",
          "BEARER_TOKEN_PLACEHOLDER": "Введите ваш bearer token",
          "USERNAME": "Имя пользователя",
          "USERNAME_PLACEHOLDER": "Введите имя пользователя",
          "PASSWORD": "Пароль",
          "PASSWORD_PLACEHOLDER": "Введите пароль",
          "API_KEY": "Имя заголовка",
          "API_KEY_PLACEHOLDER": "X-API-Key",
          "API_VALUE": "Значение заголовка",
          "API_VALUE_PLACEHOLDER": "Введите значения API key"
        },
        "PARAMETERS": {
          "LABEL": "Параметры",
          "HELP_TEXT": "Определите параметры, которые будут извлечены из запросов пользователей"
        },
        "ADD_PARAMETER": "Добавить параметр",
        "PARAM_NAME": {
          "PLACEHOLDER": "Имя параметра (например, order_id)"
        },
        "PARAM_TYPE": {
          "PLACEHOLDER": "Тип"
        },
        "PARAM_TYPES": {
          "STRING": "Строка",
          "NUMBER": "Число",
          "BOOLEAN": "Boolean",
          "ARRAY": "Массив",
          "OBJECT": "Объект"
        },
        "PARAM_DESCRIPTION": {
          "PLACEHOLDER": "Описание параметра"
        },
        "PARAM_REQUIRED": {
          "LABEL": "Обязательно"
        },
        "REQUEST_TEMPLATE": {
          "LABEL": "Шаблон тела запроса (необязательно)",
          "PLACEHOLDER": "{'{'}\n  \"order_id\": \"{'{{'} order_id {'}}'}\"\n{'}'}"
        },
        "RESPONSE_TEMPLATE": {
          "LABEL": "Шаблон ответа (необязательно)",
          "PLACEHOLDER": "Заказ {'{{'} order_id {'}}'} status: {'{{'} status {'}}'}"
        },
        "ERRORS": {
          "PARAM_NAME_REQUIRED": "Имя параметра обязательно"
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQ",
      "PENDING_FAQS": "Pending FAQs",
      "ADD_NEW": "Создать новый FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Диалог #{id}"
      },
      "SELECTED": "Выбрано {count}",
      "SELECT_ALL": "Выбрать все ({count})",
      "UNSELECT_ALL": "Сбросить все ({count})",
      "SEARCH_PLACEHOLDER": "Поиск по FAQ...",
      "BULK_APPROVE_BUTTON": "Одобрить",
      "BULK_DELETE_BUTTON": "Удалить",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQ успешно одобрены",
        "ERROR_MESSAGE": "Произошла ошибка при одобрении FAQ, пожалуйста, попробуйте ещё раз."
      },
      "BULK_DELETE": {
        "TITLE": "Удалить FAQ?",
        "DESCRIPTION": "Вы уверены, что хотите удалить выбранные FAQ? Это действие невозможно отменить.",
        "CONFIRM": "Да, удалить всё",
        "SUCCESS_MESSAGE": "FAQ успешно удалены",
        "ERROR_MESSAGE": "Произошла ошибка при удалении FAQ, пожалуйста, попробуйте ещё раз."
      },
      "DELETE": {
        "TITLE": "Вы действительно хотите удалить FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Да, удалить",
        "SUCCESS_MESSAGE": "FAQ успешно удален",
        "ERROR_MESSAGE": "Произошла ошибка при удалении FAQ, попробуйте еще раз."
      },
      "FILTER": {
        "ASSISTANT": "Ассистент: {selected}",
        "STATUS": "Статус: {selected}",
        "ALL_ASSISTANTS": "Все"
      },
      "STATUS": {
        "TITLE": "Статус",
        "PENDING": "В ожидании",
        "APPROVED": "Одобрено",
        "ALL": "Все"
      },
      "PENDING_BANNER": {
        "TITLE": "Captain has found some FAQs your customers were looking for.",
        "ACTION": "Click here to review"
      },
      "FORM_DESCRIPTION": "Добавьте вопрос и соответствующий ему ответ в базу знаний и выберите ассистента, с которым он должен связаться.",
      "CREATE": {
        "TITLE": "Добавить FAQ",
        "SUCCESS_MESSAGE": "Ответ успешно добавлен.",
        "ERROR_MESSAGE": "При добавлении ответа произошла ошибка. Пожалуйста, попробуйте еще раз."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Вопрос",
          "PLACEHOLDER": "Введите вопрос",
          "ERROR": "Пожалуйста, введите корректный вопрос."
        },
        "ANSWER": {
          "LABEL": "Ответ",
          "PLACEHOLDER": "Введите ответ",
          "ERROR": "Пожалуйста, введите корректный ответ."
        }
      },
      "EDIT": {
        "TITLE": "Обновить FAQ",
        "SUCCESS_MESSAGE": "FAQ успешно обновлён",
        "ERROR_MESSAGE": "Произошла ошибка при обновлении FAQ, пожалуйста, попробуйте ещё раз",
        "APPROVE_SUCCESS_MESSAGE": "FAQ был отмечен как одобренный"
      },
      "OPTIONS": {
        "APPROVE": "Одобрить",
        "EDIT_RESPONSE": "Редактировать",
        "DELETE_RESPONSE": "Удалить"
      },
      "EMPTY_STATE": {
        "TITLE": "FAQ не найдены",
        "NO_PENDING_TITLE": "There are no more pending FAQs to review",
        "SUBTITLE": "FAQ помогают вашему ассистенту быстро и точно отвечать на вопросы клиентов. Их можно генерировать автоматически из вашего контента или добавлять вручную.",
        "CLEAR_SEARCH": "Clear active filters",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Подключённые источники входящих",
      "ADD_NEW": "Подключить новый источник входящих",
      "OPTIONS": {
        "DISCONNECT": "Отключиться"
      },
      "DELETE": {
        "TITLE": "Вы уверены, что хотите отключить этот источник входящих?",
        "DESCRIPTION": "",
        "CONFIRM": "Да, удалить",
        "SUCCESS_MESSAGE": "Источник входящих успешно отключён.",
        "ERROR_MESSAGE": "Произошла ошибка при отключении источника входящих, пожалуйста, попробуйте ещё раз."
      },
      "FORM_DESCRIPTION": "Выберите источник входящих для подключения к ассистенту.",
      "CREATE": {
        "TITLE": "Подключить источник входящих",
        "SUCCESS_MESSAGE": "Источник входящих успешно подключён.",
        "ERROR_MESSAGE": "Произошла ошибка при подключении источника входящих. Пожалуйста, попробуйте ещё раз."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Электронная почта",
          "PLACEHOLDER": "Выберите источник входящих для развертывания ассистента.",
          "ERROR": "Необходимо выбрать источник входящих."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Нет подключённых источников входящих",
        "SUBTITLE": "Подключение источника входящих позволяет ассистенту обрабатывать первые вопросы ваших клиентов до их передачи вам."
      }
    }
  }
}
